const fa = {
  nav: {
    home: 'صفحه اصلی',
    games: 'بازی‌ها',
    myGames: 'بازی‌های من',
    gallery: 'ویترین رسانه',
    contact: 'تماس با ما',
    blog: 'بلاگ',
    about: 'درباره ما',
    terms: 'قوانین و مقررات',
    login: 'ورود',
    signup: 'ثبت‌نام',
    searchPlaceholder: 'جستجو در بازی‌ها و ویدیوها...',
    openMenu: 'باز کردن منو',
    closeMenu: 'بستن منو',
    adminPanel: 'پنل مدیریت',
  },
  hero: {
    badge: '🎮 استودیو مستقل بازی‌سازی ایرانی | Active Legend Studio',
    title: 'استودیو بازی سازی اکتیو لجند',
    subtitle: 'پیشرو در توسعه بازی‌های رقابتی رایانه و آنلاین با موتور قدرتمند Unreal Engine 5',
    viewGames: 'مشاهده بازی‌ها',
    login: 'ورود',
    signup: 'ثبت‌نام',
  },
  games: {
    title: 'بازی‌ها',
    metaTitle: 'بازی‌ها | Active Legend - مجموعه بازی‌های استودیو اکتیو لجند',
    metaDescription: 'مجموعه بازی‌های ایرانی توسعه‌یافته توسط استودیو بازی‌سازی اکتیو لجند. دانلود، مشخصات و تصاویر بازی‌ها.',
    downloadGame: 'دانلود بازی',
    editGame: 'ویرایش بازی',
    loading: 'در حال بارگذاری اطلاعات بازی...',
    notFound: 'بازی مورد نظر یافت نشد.',
    comingSoonTitle: 'هنوز منتشر نشده است (به‌زودی)',
    comingSoonDesc: 'این بازی هنوز منتشر نشده است و مراحل توسعه و پولیش فنی خود را در استودیو سپری می‌کند.',
    unavailableTitle: 'لینک دانلود در دسترس نیست',
    unavailableDesc: 'در حال حاضر فایل دانلودی برای این بازی ثبت نشده است و پس از آماده‌سازی نسخه عمومی در دسترس قرار خواهد گرفت.',
    statusReleased: 'منتشر شده',
    statusInProgress: 'در حال ساخت',
    statusComingSoon: 'به‌زودی',
    breadcrumbHome: 'صفحه اصلی',
    breadcrumbGames: 'بازی‌ها',
    latestTitle: 'تازه‌ترین بازی‌های استودیو',
    latestSubtitle: 'پروژه‌های برجسته و بازی‌های در حال توسعه با آنریل انجین ۵',
    viewAllGames: 'مشاهده همه بازی‌ها',
    gamePage: 'صفحه بازی',
    directDownload: 'دانلود مستقیم',
  },
  video: {
    watchOnYoutube: 'مشاهده مستقیم در یوتیوب',
    openYoutube: 'یوتیوب',
    unavailable: 'امکان پخش مستقیم این ویدیو وجود ندارد.',
    invalidUrl: 'آدرس ویدیو نامعتبر است.',
    captionDefault: 'ویدیو بازی',
  },
  search: {
    loading: 'در حال جستجو...',
    noResults: 'نتیجه‌ای یافت نشد.',
    games: 'بازی‌ها',
    videos: 'ویدیوها',
    noneInCategory: 'موردی یافت نشد.',
  },
  footer: {
    brandSubtitle: 'استودیو مستقل بازی‌سازی و تحریریه گیمینگ',
    rights: 'تمامی حقوق محفوظ است',
    owner: 'Active Legend Studio',
    home: 'صفحه اصلی',
    games: 'بازی‌ها',
    blog: 'وبلاگ تخصصی',
    contact: 'تماس با ما',
    about: 'درباره ما',
    terms: 'قوانین و مقررات',
  },
  notFound: {
    title: '۴۰۴',
    message: 'صفحه مورد نظر یافت نشد',
    backHome: 'بازگشت به خانه',
    metaTitle: 'صفحه یافت نشد (۴۰۴) | Active Legend',
    metaDescription: 'صفحه مورد نظر یافت نشد. بازگشت به صفحه اصلی Active Legend.',
  },
  download: {
    title: 'دانلود فایل',
    wait: 'صبر کنید...',
    linkNotFound: 'لینک یافت نشد',
    invalidId: 'آیدی وارد شده معتبر نیست یا فایل مورد نظر وجود ندارد.',
    backHome: 'بازگشت به خانه',
    countdown: 'دانلود تا',
    seconds: 'ثانیه دیگر آغاز می‌شود...',
    waitHint: 'لطفاً تا پایان شمارش صبر کنید',
    downloadButton: 'دانلود فایل',
    manualHint: 'اگر دانلود به صورت خودکار آغاز نشد، روی دکمه بالا کلیک کنید.',
    sponsorLabel: 'تبلیغات',
  },
  media: {
    title: 'ویترین رسانه‌ای و تریلرها',
    subtitle: 'ویدیوها، تریلرها و اسکرین‌شات‌های توسعه بازی‌ها',
    videoUnavailable: 'این ویدیو در حال حاضر در دسترس نیست.',
  },
  common: {
    loading: 'در حال بارگذاری...',
    language: 'زبان',
    persian: 'فارسی',
    english: 'English',
  },
} as const;

export default fa;
